// src/contexts/GoldRateContext.jsx
import React, { createContext, useState, useContext, useEffect } from "react";

const GoldRateContext = createContext();

// const DEFAULT_RATES = {
//   "18carat": 4500,
//   "22carat": 5500,
//   "24carat": 6000,
// };

export const GoldRateProvider = ({ children }) => {
    const [rates, setRates] = useState(null);
    const [showRateConfig, setShowRateConfig] = useState(false);

    useEffect(() => {
        // Load rates from localStorage on mount
        const savedRates = localStorage.getItem("gold_rates");
        if (savedRates) {
            setRates(JSON.parse(savedRates));
        } else {
            setShowRateConfig(true); // Show config if no rates exist
        }
    }, []);

    const updateRates = (newRates) => {
        const updatedRates = {
            ...newRates,
            lastUpdated: Date.now(),
        };
        setRates(updatedRates);
        localStorage.setItem("gold_rates", JSON.stringify(updatedRates));
        setShowRateConfig(false);
    };

    const getRateByCarat = (carat) => {
        if (!rates) return 0;
        return rates[carat] || 0;
    };

    const value = {
        rates,
        showRateConfig,
        setShowRateConfig,
        updateRates,
        getRateByCarat,
    };

    return (
        <GoldRateContext.Provider value={value}>
            {children}
        </GoldRateContext.Provider>
    );
};

export const useGoldRate = () => {
    const context = useContext(GoldRateContext);
    if (!context) {
        throw new Error("useGoldRate must be used within GoldRateProvider");
    }
    return context;
};